var _module = require('../../components/module');

require('./_styles.scss');
require('angular-ui-bootstrap/src/modal');
require('../lr-touch');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$inactiveListingModal', [
    '$log',
    '$uibModal',

    function $inactiveListingModal($log, $uibModal) {
        function openModal(status) {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function inactiveListingModal($scope) {
                        $scope.model = {
                            status: status
                        };
                    }
                ],
                backdrop: 'static',
                windowClass: 'inactive-listing-modal',
                keyboard: false
            });

            return modal;
        }

        return openModal;
    }
]);
